import { component } from '@/utils/component/component'
import type { IHeaderProps } from './types'
import { tv } from 'tailwind-variants'
import { isFunctionalComponent } from '@/utils/is';


const HeaderClass = tv({
  base: "w-full h-[45px] flex-col justify-center items-start gap-1 inline-flex relative",
  variants: {
    color: {
      white: {
        base: 'text-white',
        title: 'text-white',
        subtitle: 'text-white',
      },
      error: {
        base: 'text-red-800',
        title: 'text-red-800',
        subtitle: 'text-red-800'
      }
    },
    size: {
      md: {
        base: ''
      },
      lg: {
        base: 'text-lg',
        title: 'text-lg'
      },
      xl: {
        base: 'text-lg',
        title: "text-2xl font-bold font-['Inter'] leading-[30px]",
        subtitle: 'text-md'
      },
      s: {
        title: 'text-lg',
        subtitle: 'text-sm'
      },
      xs: {
        title: 'text-sm',
        subtitle: 'text-xs'
      }
    },
    centered: {
      true: {
        base: 'text-center w-full',
        titleWrapper: 'text-center justify-center w-full',
      }
    }
  },
  slots: {
    titleWrapper: "justify-start items-center gap-2 inline-flex relative",
    title: "text-gray-900 text-base font-semibold font-['Inter'] leading-none",
    subtitle: "text-gray-500 text-sm font-normal font-['Inter'] leading-[21px]"
  }
});



export const Header = component<IHeaderProps>(
  (props) => {

    const { base, title, titleWrapper, subtitle } = HeaderClass({
      color: props.variant as any,
      centered: !!props.centered,
      size: props.size as any
    });

    return () => {
      return (
        <div class={base()}>
          { props.image ? <props.image/> : null }
          <div class={titleWrapper()}>
            <div class={title()}>{
              isFunctionalComponent(props.title) ? <props.title /> : props.title
            }</div>
          </div>
          {!!props.subtitle && <div class={subtitle()}>
            {
              isFunctionalComponent(props.subtitle) ? <props.subtitle /> : props.subtitle
            }

          </div>}
        </div>
      )
    }
  },
  ['title', 'subtitle', 'variant', 'size', 'centered', 'image']
)
